import { SOURCES } from './constants/sources';

export const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3456/';
export const BASE_URL = import.meta.env.VITE_BASE_URL || 'http://localhost:3456';
export const STORE_LOGGER = import.meta.env.VITE_STORE_LOGGER || true;
export const S3_IMAGES_URL = import.meta.env.VITE_S3_IMAGES_URL || 'http://localhost:3456/images';
export const S3_AUDIO_URL = import.meta.env.VITE_S3_AUDIO_URL || 'http://localhost:3456/audios';
export const S3_GEOGEBRA_URL = import.meta.env.VITE_S3_GEOGEBRA_URL || 'http://localhost:3456/geogebra';
export const ANIMATION_URL = import.meta.env.VITE_ANIMATION_URL || 'http://localhost:3456';
export const CHECKER_URL = import.meta.env.VITE_CHECKER_URL || 'https://rm.zanichelli.it/checker/check-expression';
export const BASE_NAME_APP = import.meta.env.VITE_BASE_NAME_APP || '';
export const RECAPTCHA_SITE_KEY = import.meta.env.VITE_RECAPTCHA_SITE_KEY || '';
export const STATUS_SYNC_INTERVAL = import.meta.env.VITE_STATUS_SYNC_INTERVAL || '10000';
export const SCHOOL_TEACHER_GROUP_ID = 15;
export const UNIVERSITY_TEACHER_GROUP_ID = 25;
export const FUNCTIONARY_GROUP_ID = 17;
export const SOURCES_WITH_THEORIES = import.meta.env.VITE_SOURCES_WITH_THEORIES
    ? JSON.parse(import.meta.env.VITE_SOURCES_WITH_THEORIES)
    : [SOURCES.TT];
export const BUILD_YEAR = import.meta.env.VITE_BUILD_YEAR || '2021';
export const VIRTUAL_CLASS_URL =
    import.meta.env.VITE_VIRTUAL_CLASS_URL || 'https://registro-dev.dev-classivirtuali.aglebert.zanichelli.it/#!';

export const GAPI_CLIENT_ID =
    import.meta.env.VITE_GAPI_CLIENT_ID || '635017119654-e198jgr6oia3g5qdk4a1c70mohu9n6iv.apps.googleusercontent.com';
export const GAPI_API_KEY = import.meta.env.VITE_GAPI_API_KEY || 'AIzaSyC6QYprV6uyx6Qq2FER2ma0CTMvQvtl5Go';
export const GAPI_DISCOVERY_DOCS = import.meta.env.VITE_GAPI_DISCOVERY_DOCS || [
    'https://www.googleapis.com/discovery/v1/apis/classroom/v1/rest',
];
export const GAPI_SCOPES =
    import.meta.env.VITE_GAPI_SCOPES ||
    'https://www.googleapis.com/auth/classroom.rosters.readonly https://www.googleapis.com/auth/classroom.courses.readonly https://www.googleapis.com/auth/classroom.coursework.me.readonly https://www.googleapis.com/auth/classroom.coursework.students.readonly';
export const ZANICHELLI_IDP_PINGINTERVAL = +(import.meta.env.VITE_ZANICHELLI_IDP_PINGINTERVAL || '0'); // millis
export const IDP_ENDPOINT = import.meta.env.VITE_IDP_ENDPOINT || 'https://idp.zanichelli.it';
export const STATEMENTS_URL = import.meta.env.VITE_STATEMENTS_URL || 'http://localhost:3456/api/statements';
